module.exports = __webpack_public_path__ + "img/BABO-02.ff4e553b.png";